"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
var _default = {
  people: {
    batcherWait: 100,
    batcherMaxCalls: 10,
    batcherMaxWait: 1500,
    /**
     * optional flag that requires Hydra to send every type field,
     * even if the type is not "person" (e.g.: SX10, webhook_integration, etc.)
     * @private
     */
    showAllTypes: false
  }
};
exports.default = _default;
//# sourceMappingURL=config.js.map
